jQuery(document).ready(function () {
  jQuery('.content-slider').on('init', function(){
    $('#slider-loading').hide();
    $('.content-slider').fadeIn(200);
  });
  
  jQuery('.content-slider').slick({
    dots: false,
    navigation: false,
    autoplay: true,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1
  });
  
  jQuery('.testimonial-slider').slick({
    dots: false,
    navigation: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });

  //navigation active according scrolling
  const $links = $('.subnav-wrapper a');
  const offset = 300; // Adjust based on your fixed header height, if any

  const sections = $links.map(function () {
    const target = $(this).attr('href');
    return $(target).length ? $(target) : null;
  });

  $(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop() + offset;

    let current = sections.map(function () {
      if ($(this).offset().top <= scrollTop) {
        return this;
      }
    });

    current = current[current.length - 1];
    const id = current && current.length ? current.attr('id') : '';

    $links.removeClass('w--current');
    if (id) {
      $links.filter('[href="#' + id + '"]').addClass('w--current');
    }
  });

  // Trigger on load in case page loads midway
  $(window).trigger('scroll');

  //fixed the sticky bar in device accessories page.
  var subnav = $(".stickybar");
  $(window).on("scroll", function(){
    if($(window).scrollTop() > 300) {
      subnav.addClass("subnav-fixed");
    } else {
      subnav.removeClass("subnav-fixed");
    }
  });

  //menu closing
  $(document).on('click', '#link-resources a.menu-drawer__menu-item', function() {
    $('#Details-menu-drawer-container')
      .removeClass('menu-opening')
      .removeAttr('open');
    $('#Details-menu-drawer-container summary').attr('aria-expanded', false);
  });
  

});

//openstreetMap View
const locations = [
  { title: 'Synergy Integrative Specialty Veterinary Clinic', subtitle:'', address: '4005 Dr. M.L.K. Jr Blvd, New Bern, NC 28562', lat: 35.094521, lng: -77.116882 },
  { title: 'Aurora Animal Hospital', subtitle:'', address: '1201 College Rd, Fairbanks, AK 99701', lat: 64.859701, lng: -147.737049 },
  { title: 'OrthoPaws', subtitle:'', address: '34896 US Hwy 19 N, Palm Harbor, FL 34684, United States', lat: 28.089316, lng: -82.740745 },
  { title: 'Paws in Motion', subtitle: 'Also known as American Limb', address: '201 E. Morthland Drive, Suite 2, Valparaiso, Indiana 46383', lat: 41.458516, lng: -87.058541 },
  { title: 'Wissahickon Creek Vet Hospital', subtitle:'Special hours with certain personnel', address: '7376 Ridge Ave, Philadelphia, PA 19128', lat: 40.047620, lng: -75.235540 },
  { title: 'Arun Veterinary Group', subtitle:'', address: 'Mill Stream Car Park, Library, North St, Storrington, Pulborough RH20 4DH, UK', lat: 50.918270, lng: -0.453830 },
  { title: 'Alpha Animal Rehabilitation and Fitness', subtitle:'', address: '316 3rd Ave, Alpha, NJ 08865', lat: 40.668663, lng: -75.157807 },
  { title: 'Canine Kinetics', subtitle:'', address: '6/11 Mount St, Prahran, Victoria, Australia 3181', lat: -37.851360, lng: 144.995728 },
  { title: 'Melbourne Animal Physiotherapy', subtitle:'', address: '26a Robertson Street, Kensingtown, VIC 3015', lat: -37.793310, lng: 144.934020 },
  { title: 'HandicappedPets Australia', subtitle:'', address: '24 Newman St. Semaphhore, South Australia, Australia 5019', lat: -34.839520, lng: 138.481770 },
  { title: 'Tiereliebe Mit Handicap', subtitle:'', address: 'Sondershäuser Landstraße 20, 99974 Mühlhausen/Thüringen, Germany', lat: 51.21458334272532, lng: 10.481774284783405 },
  { title: '2Hands4Paws', subtitle:'', address: '2240 Federal Ave, Los Angeles, CA 90064', lat: 34.03463772895416, lng: -118.44484870226876 },
  { title: 'My Pet\'s Brace', subtitle:'', address: '3508 Main St, Morgantown, PA 19543', lat: 40.15685365173679, lng: -75.8822630333313 }
];

const customIcon = new L.Icon({
  iconUrl: 'https://' + 'cdn.shopify.com/s/files/1/0670/0934/7638/files/marker-icon.png',
  shadowUrl: 'https://' + 'cdn.shopify.com/s/files/1/0670/0934/7638/files/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const openMapElement = document.getElementById('openMap');
if (openMapElement) {
  const map = L.map('openMap', {
    renderer: L.canvas()
  }).setView([7.925679, -73.968285], 1);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(map);

  const markers = [];

  locations.forEach((loc, index) => {
    const marker = L.marker([loc.lat, loc.lng], {icon: customIcon}).addTo(map)
      .bindPopup(`<img src="https://cdn.shopify.com/s/files/1/0670/0934/7638/files/64e37f7e3999ade2a5333040_Screenshot_2023-08-21_at_11.14.52_AM.png?v=1751347546"><h3>${loc.title}</h3><div>${loc.address}</div>`);

    markers.push(marker);

    $('#sideBar').append(`
      <div class="location-item" data-index="${index}">
        <img src="https://cdn.shopify.com/s/files/1/0670/0934/7638/files/5cabf0d_PAWvider.png?v=1753841470" />
        <div>
          <h3>${loc.title}</h3>
          <i>${loc.subtitle}</i>
          <p>${loc.address}</p>
        </div>
      </div>
    `);

    $('#sideBar').on('click', '.location-item', function() {
      const index = $(this).data('index');
      const marker = markers[index];

      map.setView(marker.getLatLng());
      marker.openPopup();
    });
  });
}

